<template>
  <div>
    <label v-if="label" class="block mb-2 text-sm" :for="name">{{ label }}</label>
    <Field class="block w-full border border-gray-200" as="select" :id="name" :name="name" v-model="model">
      <option disabled :value=null>Valitse paikkakunta</option>
      <option v-for="option in options" :key="option.id" :value="option.id">{{ option.name }}</option>
    </Field>
    <ErrorMessage class="mt-2 text-xs text-red-500"  :name="name" />
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Select',
  components: { Field, ErrorMessage },
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: false,
      default: () => null,
      type: String
    },
    rules: {
      required: false,
      default: () => null,
      type: Function,
    },
    options: {
      required: true,
      type: Array
    }
  },
  setup({ name }) {
    const store = useStore()

    const model = computed({
      get () {
        return store.getters.resolve(name)
      },
      set (value) {
        store.commit('set', { name, value: value ? Number(value) : null })
      }
    })

    return {
      model,
    }
  }
}
</script>
